'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var HomeCleaning = function HomeCleaning(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M20.8819859,1.5 L22.5,3.11801411 L15.9823657,9.62425393 C17.2015735,11.3790016 17.3724905,13.4869778 16.3469886,14.8543136 L9.14568638,7.65301139 C10.5130222,6.6275095 12.6209984,6.79842648 14.3757461,8.01763429 L20.8819859,1.5 L20.8819859,1.5 Z M5.57921867,18.4207813 C3.28893109,16.1304938 1.88741183,13.395822 1.5,10.8434617 L7.06049919,8.46201845 L15.5379816,16.9395008 L13.1565383,22.5 C10.604178,22.1125882 7.86950624,20.7110689 5.57921867,18.4207813 Z"
  }));
};

var HomeCleaning$1 = iconStyles()(HomeCleaning);

module.exports = HomeCleaning$1;
